import styled from '@emotion/styled';
import { SubtitleText } from '@shared/components/core/text/Typography';
import { color } from '@shared/constants/Styles';
import MacroCard from '../../macro/MacroCard';
import { CardStyle } from '../card/LegacyCard';

export const List = styled.ul`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

export const ColumnList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
`;

export const EmptyContent = styled.div`
    font-style: italic;
    font-weight: 300;
    grid-column: 1 / span 2;
    padding: 1rem;
    text-align: center;
`;
export const Content = styled.td`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    :nth-of-type(even) {
        grid-column: 2;
        justify-content: flex-end;
        text-align: right;
    }
    :nth-of-type(odd) {
        grid-column: 1;
        justify-content: flex-start;
        text-align: left;
    }
`;
export const Table = styled.table`
    width: 100%;
`;
export const TableHeading = styled(SubtitleText)`
    text-align: inherit;
`;

export const ListingCard = styled(CardStyle)`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    max-width: 800px;
    width: calc(100% - 2rem);
    padding: 40px;
`;
export const ActionWrapper = styled.tr`
    display: grid;
    gap: 1rem;
    grid-template-columns: auto auto;
    padding: 1rem 0;
    width: 100%;
    :not(:only-child):not(:last-child) {
        border-bottom: solid 1px ${color.primary_dark}20;
    }
`;

export const MacroWrap = styled.div`
    margin: 1rem;
    display: flex;
    width: calc(100% - 2rem);
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding-bottom: 1rem;
`;
export const AttachedMacroCard = styled(MacroCard)`
    background-color: ${(props) => props.theme.color.accentCard};
    box-shadow: none;
    border-top: none !important;
`;
